export enum HhsAssignedGender {
    F = 'F',
    M = 'M',
    U = 'U',
}

export enum HhsAuthorizedBy {
    Patient = 'patient',
    Representative = 'patientRepresentative',
}

export enum HhsBestTimeToCall {
    Afternoon = 'afternoon',
    Evening = 'evening',
    Morning = 'morning',
}

export enum HhsGenderIdentity {
    Male = 'M',
    Female = 'F',
    FTM = 'FTM',
    MTF = 'MTF',
    NonConforming = 'GNC',
    Unknown = 'U',
}

export enum HhsInitiator {
    AssistRx = 'ARX',
    Trialcard = 'TC',
}

export enum HhsPhoneType {
    Home = 'home',
    Mobile = 'mobile',
    Work = 'work',
}

export enum HhsProduct {
    Descovy = 'Descovy',
    Truvada = 'Truvada',
}

export enum HhsRace {
    White = 1,
    Black = 2,
    Asian = 3,
    NativeAmerican = 4,
    PacificIslander = 5,
    Multiple = 6,
    NoAnswer = 9,
}

export enum HhsStatus {
    AlreadyEnrolled = 'AlreadyEnrolled',
    Enrolled = 'Enrolled',
    Expired = 'Expired',
    Rejected = 'Rejected',
    Unknown = 'Unknown',
}

export enum HhsSource {
    Interest = 'interest',
    Prescriber = 'prescriber',
}
